module.exports = __webpack_public_path__ + "static/media/monitoring-min.2357e96e.webp";